import { render, staticRenderFns } from "./Persontipper.vue?vue&type=template&id=12cd470c"
import script from "./Persontipper.vue?vue&type=script&lang=js"
export * from "./Persontipper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports